type School = {
  roles?: string[];
};

type SchoolClass = {
  teachers?: { id: string }[];
};

type OidcUser = {
  profile?: {
    user?: string;
    username?: string;
  };
};

export const getUserRoles = (school: School | undefined | null): string[] => {
  if (!school || !school.roles) return [];

  return school.roles;
};

export const hasASchool = (school: School | undefined | null): boolean => {
  return getUserRoles(school).length > 0;
};

export const isSchoolOwner = (userRoles: string[]): boolean => {
  return userRoles.includes("owner");
};

export const isSchoolTeacher = (userRoles: string[]): boolean => {
  return userRoles.includes("teacher");
};

export const isSchoolStudent = (userRoles: string[]): boolean => {
  return userRoles.includes("student");
};

export const isSchoolTeacherOrOwner = (userRoles: string[]): boolean => {
  return isSchoolOwner(userRoles) || isSchoolTeacher(userRoles);
};

export const isClassTeacher = (
  userRoles: string[],
  user: OidcUser | undefined | null,
  schoolClass: SchoolClass,
): boolean => {
  return (
    !!user?.profile?.user &&
    isSchoolTeacher(userRoles) &&
    !!schoolClass.teachers
      ?.map((teacher) => teacher.id)
      .includes(user.profile.user)
  );
};

export const isUnder13inProfile = (
  user: OidcUser | undefined | null,
): boolean => {
  // todo: Ideally we would match Profile's logic:
  //  (https://github.com/RaspberryPiFoundation/profile/blob/1d1166816bea19f822c68bb2a604d6e403b99116/app/models/user.js#L116).
  //  We don't have all the fields available here yet. Username works as a general heuristic, but not(!) for SSO users.

  return !!user?.profile?.username;
};
